module.exports = __webpack_public_path__ + "img/reply.e0f0f6ac.png";